
export const catalogs = "collections/catalogs"
